export default __webpack_public_path__ + "static/media/FG_14.86dbb3ed.jpg";